import ActivityList from '@/pages/activity-manage/activity-list';
import provideActivityLink from '@/components/provide-activity-link';

export default function ActivityMain(props: any) {
  return (
    <provideActivityLink.activitymanage>
      <ActivityList {...props} />
    </provideActivityLink.activitymanage>
  );
}
